// Client-side slug preview helper. Mirrors the backend's deriveSlug
// (packages/api/src/shared/tenants.ts) closely enough for the wizard's
// `{slug}.gc-coach.ai` preview field — the backend is authoritative and
// will overwrite with its own derivation on create.

export function deriveSlug(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 50);
}
